<mat-card-content dir="{{ languageDir }}">
  <ngx-spinner
    bdColor="rgba(0, 0, 0, 0.8)"
    template=" <img src='assets/images/spinner.gif' />"
  >
  </ngx-spinner>
  <div class="content-top-box">
    <app-bread-crumb></app-bread-crumb>
  </div>
  <div class="content">
    <div class="header-title">
      <h1 class="main-title">
        {{t('Technician', 'Technician')}}
      </h1>
    </div>
    <div class="form-content">
      <form [formGroup]="HeaderForm" class="w-70">
        <div class="w-100 headerForm d-flex">
          <div class="inputField" style="width: 400px">
            <nz-range-picker
              class="calender-input"
              [nzInputReadOnly]="true"
              [nzShowTime]="false"
              nzFormat="dd-MMM-yyyy"
              formControlName="datePicker"
              [nzDisabledDate]="disabledDate"
              (ngModelChange)="getFilterData()"
            >
            </nz-range-picker>
            <span class="floating-text">{{t('DateRange', 'Date Range')}}</span>
          </div>
          <mat-form-field appearance="fill" class="w-20">
            <mat-label>{{t('Search', 'Search')}}</mat-label>
            <input
              matInput
              type="text"
              (keyup)="onFilterChanged($event.target)"
            />
          </mat-form-field>
        </div>
      </form>
      <div class="import_export">
        <button
          *ngIf="isAccess | permissionChecker"
          class="export"
          (click)="ExportTOExcel()"
        >
          {{t('Export', 'Export')}}
        </button>
      </div>
    </div>
  </div>

  <div
    *ngIf="selectedFilter === 0"
    class="d-flex justify-content-center"
    style="margin-top: 50px"
  >
    <div class="score-cards-wrapper d-flex" style="gap: 12px">
      <mat-card
        class="open"
        style="padding: 10px; text-align: center; background-color: #f8f9fa"
      >
        <b color="warn"
          >{{t('OpenedTasks', 'Opened Tasks')}} :
          {{ openCount }}</b
        >
      </mat-card>
      <mat-card
        class="closed"
        style="padding: 10px; text-align: center; background-color: #e9ecef"
      >
        <b
          >{{t('ClosedTasks', 'Closed Tasks')}} :
          {{ closedCount }}</b
        >
      </mat-card>
      <mat-card
        class="completed"
        style="padding: 10px; text-align: center; background-color: #f1f3f5"
      >
        <b
          >{{t('CompletedTasks', 'Completed Tasks')}}
          : {{ completedCount }}</b
        >
      </mat-card>
      <mat-card
        class="inprogress"
        style="padding: 10px; text-align: center; background-color: #f1f3f5"
      >
        <b
          >{{t('InprogressTasks', 'In-progress Tasks')}}
          : {{ inProgressCount }}</b
        >
      </mat-card>
 <!-- <mat-card
        class="delayed"
        style="padding: 10px; text-align: center; background-color: #f1f3f5"
      >
        <b
          >{{t('DelayedTasks', 'Delayed Tasks')}}
          : {{ delayedCount }}</b
        >
      </mat-card> -->
    </div>
  </div>

  <div class="tab">
    <mat-tab-group
      mat-align-tabs="start"
      [(selectedIndex)]="selectedFilter"
      (selectedTabChange)="getFilterData()"
    >
      <mat-tab
        label="{{t('WorkOrder', 'Work Order')}}"
      >
        <div style="margin-top: 20px">
          <div class="responsive-grid-shell">
            <ag-grid-angular
              class="ag-theme-alpine responsive-grid"
              [rowData]="woList"
              [columnDefs]="woColumnDefs"
              (gridReady)="onGridReady($event)"
              (cellClicked)="cellClicked($event)"
              [gridOptions]="gridOptionsWO"
              [pagination]="true"
              [paginationPageSize]="10"
              [frameworkComponents]="frameworkComponents"
            >
            </ag-grid-angular>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="{{t('PMTask', 'PM Task')}}">
        <div style="margin-top: 20px">
          <div class="responsive-grid-shell">
            <ag-grid-angular
              class="ag-theme-alpine responsive-grid"
              [rowData]="pmTaskList"
              [columnDefs]="pmColumnDefs"
              (gridReady)="onGridReady($event)"
              (cellClicked)="cellClicked($event)"
              [gridOptions]="gridOptionsPM"
              [pagination]="true"
              [paginationPageSize]="10"
              [frameworkComponents]="frameworkComponents"
            >
            </ag-grid-angular>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>

  <ng-template #imageViewModal>
    <button mat-mini-fab color="warn" (click)="oncloseimg()">
      <mat-icon>close</mat-icon>
    </button>
    <mat-carousel
      timings="250ms ease-in"
      [autoplay]="false"
      interval="5000"
      color="accent"
      [loop]="true"
      [hideArrows]="false"
      [hideIndicators]="false"
      [useKeyboard]="true"
      [useMouseWheel]="true"
      orientation="ltr"
    >
      <mat-carousel-slide
        #matCarouselSlide
        *ngFor="let slide of slidesImages; let i = index"
        [image]="blobStorageUrl + slide"
        overlayColor="#00000040"
        [hideOverlay]="false"
      ></mat-carousel-slide>
    </mat-carousel>
  </ng-template>
</mat-card-content>
